





































































































import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import Translate from "@/consoleapi/api/translate";

import OutstandingApi from "@/consoleapi/api/outstanding";

@Component
export default class OutstandingInput extends Vue {
    @Prop() bearerToken!: string;
    @Prop() accountId!: string;
    @Prop() userId!: string;

    @Prop() taxExclusion!: number;
    @Prop() tax!: number;
    @Prop() taxIncluded!: number;
    @Prop() date!: string;
    @Prop() outstandingInvoiceId!: string;

    private phoneNumber = '';
    private mailAddress = '';
    private creditCardName = '';
    private creditCardNumber = '';
    private creditCardExpirationYear = '';
    private creditCardExpirationMonth = '';

    public thisYear = '';

    mounted(): void {
        // クレジットカードフォーム用
        const date = new Date();
        this.thisYear = date.getFullYear().toString().substr(2,2);
    }

    goConfirmPage(event: Event) {
        if (event) {
            event.preventDefault()
        }
        if(!this.validation()) {
            return;
        }
        const outstandingApi = new OutstandingApi();
        outstandingApi.setBearerToken(this.bearerToken);
        outstandingApi.payment(this.accountId, this.creditCardNumber, this.creditCardExpirationYear, this.creditCardExpirationMonth, this.creditCardName, this.phoneNumber, this.mailAddress, this.outstandingInvoiceId).then(response => {
            // console.log(response.data);
            this.inputOutstandingInvoiceIdEmit('');
            this.$store.dispatch('outstanding/pushProgress', 'result');
        }).catch(error => {
            // console.log(error.response);
            alert('支払いに失敗しました。\n' + error.response.statusText)
        });
    }

    private validation(){
        if (!this.creditCardName) {
            alert('クレジットカード名義を入力してください。');
            return false;
        }
        if (!this.creditCardNumber) {
            alert('クレジットカード番号を入力してください。');
            return false;
        }
        if (!this.creditCardExpirationYear) {
            alert('有効期限年を指定してください。');
            return false;
        }
        if (!this.creditCardExpirationMonth) {
            alert('有効期限月を指定してください。');
            return false;
        }
        if (!this.phoneNumber) {
            alert('電話番号を入力してください。');
            return false;
        }
        if (!this.mailAddress) {
            alert('メールアドレスを入力してください。');
            return false;
        } else if (!this.validEmail(this.mailAddress)){
            alert('メールアドレスの形式に誤りがあります。');
            return false;
        }
        return true;
    }

    validEmail (email: string){
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    private priceFormat(price: number){
        return price.toLocaleString();
    }

    private calcYear(index: number){
        return Number(this.thisYear) + index - 1;
    }

    @Emit()
    public inputOutstandingInvoiceIdEmit(inputOutstandingInvoiceId: string) {
        // console.log('Emit2=>' + inputOutstandingInvoiceId);
    }
}
